import { render, staticRenderFns } from "./address-details.vue?vue&type=template&id=4ebc33d0&scoped=true"
import script from "./address-details.vue?vue&type=script&lang=js"
export * from "./address-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebc33d0",
  null
  
)

export default component.exports